import { render } from "./TableExpandableRow.vue?vue&type=template&id=e2a8b5e6&scoped=true"
import script from "./TableExpandableRow.vue?vue&type=script&lang=js"
export * from "./TableExpandableRow.vue?vue&type=script&lang=js"

import "./TableExpandableRow.vue?vue&type=style&index=0&id=e2a8b5e6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a8b5e6"]])

export default __exports__